import {Image} from "helpers/RenderUtil";
import {Skeleton, useTheme} from "@mui/material";
import {CorporateIdentityContext} from "../../../config/corporateIdentity";
import {SxProps} from "@mui/system/styleFunctionSx";
import {Theme} from "@mui/material/styles";
import {useContext, useEffect, useState, useTransition} from "react";
import {fetchStartContent} from "../../tenant_login/requests/Login";
import {currentTenant} from "helpers/Application";
import config from "config";

const AppLogo = (sx?: SxProps<Theme>, width?: number, height?: number) => {
  const theme = useTheme();
  const corporateIdentity = useContext(CorporateIdentityContext);
  const [isPending, startTransition] = useTransition();
  const [logo, setLogo] = useState<string>(corporateIdentity[`logo_app_${theme.palette.mode}_path`]);

  useEffect(() => {
    startTransition(async () => {
      let startItemContent = await fetchStartContent(currentTenant());

      if (startItemContent.content.length === 0) {
        startItemContent = await fetchStartContent("global");
      }

      startTransition(() => {
        if(startItemContent.content[0]?.loginFormIcon?.url) {
          setLogo(config.qurasoftApiBaseUrl + startItemContent.content[0]?.loginFormIcon?.url);
        }
      });
    });
  }, []);

  if(isPending) {
    return <Skeleton variant={"rounded"} height={50} width={50} />;
  } else {
    return (
      <Image
        src={logo}
        alt="Praxis Logo"
        width={width}
        height={height}
        sx={
          {
            borderRadius: 2,
            height: theme => theme.spacing(7),
            ...sx
          }
        }
      />
    );
  }
};

export {AppLogo};
